import React from 'react'
import Navbar from '../components/Navbar'
import Report from '../components/Report'
import MonthlyReports from '../components/MonthlyReports'

const Reports = () => {
  return (
    <div>
        <Navbar/>
        <MonthlyReports/>
    </div>
  )
}

export default Reports